import fetchApi from './fetch';

export function getSubscriptionStatus() {
  return fetchApi('/subscription/status', 'POST', null, true);
}